<template>
  <el-card>
    <checked-quotation
      :quotation-list="quotationList"
      :opt-type="optType"
    />
    <footer-bar>
      <el-button
        type="primary"
        @click="toSubmit"
      >
        发 布
      </el-button>
      <el-button @click="handleClose">
        取 消
      </el-button>
    </footer-bar>
  </el-card>
</template>

<script>
import api from '@/api'
import CheckedQuotation from './checked-quotation'
export default {
  name: 'BatchTrade',
  components: {
    CheckedQuotation
  },
  props: {
    quotationList: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      optType: 'trade',

    }
  },
  created () {
    this.quotationList.map(item => {
      this.$set(item, 'totalQuantity', 0)
      if (item.priceType === 'DX') {
        this.$set(item, 'priceList', [{
          unitPrice: '',
          min: '',
          max: ''
        }])
      }
    })
  },
  methods: {
    toSubmit () {
      let batchTender = []
      let check = true
      this.quotationList.some(item => {
        if (!item.totalQuantity) {
          check = false
          return true
        }
        batchTender.push({
          quotationId: item.id,
          totalQuantity: item.totalQuantity,
          priceList: item.priceList,
        })
      })
      if (!check) {
        this.$message.warning('挂牌库存必传')
        return
      }
      api.myStore.batchCreateTrade({ batchTender }).then(res => {
        this.$message.success('操作成功')
        this.$emit('refresh')
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit('close')
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
